export default __webpack_public_path__ + "static/media/1920 utensils side.f0b3a2b4.png";